<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="角色名称" prop="roleName">
				<el-input clearable v-model="editForm.roleName" class="input_200px" size="small" auto-complete="off" placeholder="请输入角色名称"></el-input>
			</el-form-item>
			<el-form-item label="角色描述" prop="desc">
				<el-input v-model="editForm.desc" class="input_200px" type="textarea" auto-complete="off" placeholder="请输入角色描述"></el-input>
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { SaveRoleInfo, GetRoleInfoDetail } from "../../../api/userApi.js";
export default {
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				roleName: "",
				desc: ""
			},
			// rules 表单验证
			rules: {
				roleName: [
					{
						required: true,
						message: "请输入角色名称",
						trigger: "blur"
					}
				]
			}
		};
	},
	computed: {},
	watch: {},

	methods: {
		//显示编辑界面
		editShow(row) {
			if (row != undefined && row != "undefined") {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				GetRoleInfoDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.editForm = res.data;
							this.editFormVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("角色信息获取失败!");
					});
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editFormVisible = true;
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveRoleInfo(this.editForm)
						.then((res) => {
							this.editFormVisible = false;
							this.loading = false;
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "角色保存成功！"
								});
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("角色保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
</style>
